import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";
import ShippingGuide from "../pages/shipping-guide/page";
import CouponGuide from "../pages/coupon-guide/page";
import ReviewPage from "../pages/review/page";
import WarehouseGuide from "../pages/warehouse-guide/page";
import BeginnersGuide from "../pages/beginners-guide/page";
import BestFinds from "../pages/best-finds/page";
import VsAlternatives from "../pages/vs-alternatives/page";
import Tutorial from "../pages/tutorial/page";
import StreetwearGuide from "../pages/streetwear-guide/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/sugargoo-spreadsheet-guide",
    element: <ArticlePage />,
  },
  {
    path: "/sugargoo-shipping-cost-guide",
    element: <ShippingGuide />,
  },
  {
    path: "/sugargoo-coupon-discount-guide",
    element: <CouponGuide />,
  },
  {
    path: "/sugargoo-review-legit",
    element: <ReviewPage />,
  },
  {
    path: "/sugargoo-warehouse-qc-guide",
    element: <WarehouseGuide />,
  },
  {
    path: "/sugargoo-beginners-guide",
    element: <BeginnersGuide />,
  },
  {
    path: "/best-sugargoo-spreadsheet-finds",
    element: <BestFinds />,
  },
  {
    path: "/sugargoo-vs-alternatives",
    element: <VsAlternatives />,
  },
  {
    path: "/sugargoo-spreadsheet-tutorial",
    element: <Tutorial />,
  },
  {
    path: "/sugargoo-spreadsheet-streetwear",
    element: <StreetwearGuide />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;